export { resolveFile } from "./amazonUpload";
export { resolveFileCloudinary } from "./cloudinaryUpload";
